<template>
  <div class="help-question-list">
    <template v-if="multiple">
      <tml-expandable-container
        v-for="question in questionList"
        :key="question.id"
        class="question"
        :title="question.question"
        @click="onQuestionSelect(question)"
      >
        <tml-contact-form
          v-if="
            question.question ===
            'I\'d like to report an Intellectual Property/Copyright Infringement'
          "
        />
        <help-track-order
          v-if="question.question === 'Where is my order?'"
          @not-arrived="onNotArrived"
        />
        <help-return-order
          v-else-if="question.question === 'How do I return my order?'"
        />
        <help-edit-order
          v-else-if="question.question === 'How do I edit my order?'"
        />
        <help-cancel-order
          v-else-if="question.question === 'How do I cancel my order?'"
        />
        <span v-else class="answer" v-html="question.answer" />
        <p class="mb-4 mt-8 helpful">Did this answer your question?</p>
        <div class="flex button-tray">
          <div class="button-tray-item">
            <tml-button
              fill
              :icon="faThumbsUp"
              :loading="loadingHelpful"
              @click="onHelpful(question)"
            />
          </div>
          <div class="button-tray-item">
            <tml-button
              fill
              :icon="faThumbsDown"
              :loading="loadingUnhelpful"
              @click="onUnHelpful(question)"
            />
          </div>
        </div>
      </tml-expandable-container>
    </template>
    <template v-else>
      <tml-expandable-container
        style="padding-bottom: 10vh"
        class="question"
        :title="questionList.question"
        start-open
        @click="onQuestionSelect(questionList)"
      >
        <help-track-order
          v-if="questionList.question === 'Where is my order?'"
          @not-arrived="onNotArrived"
        />
        <help-return-order
          v-else-if="questionList.question === 'How do I return my order?'"
        />
        <help-cancel-order
          v-else-if="questionList.question === 'How do I cancel my order?'"
        />
        <help-edit-order
          v-else-if="questionList.question === 'How do I edit my order?'"
        />
        <span v-else class="answer" v-html="questionList.answer" />
        <p class="mb-4 mt-8 helpful">Did this answer your question?</p>
        <div class="flex button-tray">
          <div class="button-tray-item">
            <tml-button
              fill
              :icon="faThumbsUp"
              :loading="loadingHelpful"
              @click="onHelpful(questionList)"
            />
          </div>
          <div class="button-tray-item">
            <tml-button
              fill
              :icon="faThumbsDown"
              :loading="loadingUnhelpful"
              @click="onUnHelpful(questionList)"
            />
          </div>
        </div>
      </tml-expandable-container>
    </template>
  </div>
</template>

<script>
import VueCookie from 'vue-cookie';
import {formatUrl} from '@teemill/common/helpers';
import {faThumbsUp, faThumbsDown} from '@fortawesome/pro-light-svg-icons';
import HelpTrackOrder from './HelpTrackOrder.vue';
import HelpReturnOrder from './HelpReturnOrder.vue';
import HelpCancelOrder from './HelpCancelOrder.vue';
import HelpEditOrder from './HelpEditOrder.vue';
export default {
  name: 'HelpQuestionList',

  components: {
    HelpTrackOrder,
    HelpReturnOrder,
    HelpCancelOrder,
    HelpEditOrder,
  },

  inject: ['app'],

  props: {
    questionList: [Object, Array],

    multiple: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['unhelpful'],

  data() {
    return {
      faThumbsUp,
      faThumbsDown,
      question: null,
      loadingHelpful: false,
      loadingUnhelpful: false,
      open: true,
    };
  },

  computed: {
    project() {
      return (
        this.$project?.active?.id || this.$store.state.subdomain?.project?.id
      );
    },

    isSubdomain() {
      return this.app.isSubdomain;
    },
  },

  methods: {
    onQuestionSelect(question) {
      this.question = question;

      if (!VueCookie.get(`faq-${this.question.id}-clicked`)) {
        this.axios.post(formatUrl('/omnis/v3/contact/log-clicked/'), {
          question_id: this.question.id,
        });
      }
      VueCookie.set(`faq-${this.question.id}-clicked`, true, {expires: 1});
    },

    onHelpful(question) {
      this.loadingHelpful = true;
      this.question = question;

      if (!VueCookie.get(`faq-${this.question.id}-helpful`)) {
        if (this.isSubdomain) {
          this.axios.post(
            formatUrl(`/omnis/v3/contact/${this.question.id}/new-faq-vote/`),
            {
              project: this.project,
              helpful: true,
            }
          );

          this.loadingHelpful = false;
          this.$dialogs.showSnackBar({
            message: 'Thanks! We appreciate your feedback 👍',
            type: 'success',
          });
          VueCookie.set(`faq-${this.question.id}-helpful`, true, {
            expires: 1,
          });
        } else {
          this.axios
            .post(formatUrl('/omnis/v3/contact/log-helpful/'), {
              question_id: this.question.id,
            })
            .then(({data}) => {
              this.loadingHelpful = false;
              this.$dialogs.showSnackBar(data);
              VueCookie.set(`faq-${this.question.id}-helpful`, true, {
                expires: 1,
              });
            })
            .catch(() => {
              this.loadingHelpful = false;
              this.$dialogs.showSnackBar({
                message: 'Oops! Something went wrong, please try again later',
                type: 'error',
              });
            });
        }
      } else {
        this.$dialogs.showSnackBar({
          message: 'You can only rate a question once.',
          type: 'error',
        });
        this.loadingHelpful = false;
      }
    },

    onUnHelpful(question) {
      this.loadingUnhelpful = true;
      this.question = question;

      if (!VueCookie.get(`faq-${this.question.id}-helpful`)) {
        if (this.isSubdomain) {
          this.axios.post(
            formatUrl(`/omnis/v3/contact/${this.question.id}/new-faq-vote/`),
            {
              project: this.project,
              helpful: false,
            }
          );

          this.loadingUnhelpful = false;
          this.$emit('unhelpful', question);
          this.$dialogs.showSnackBar({
            message: 'Thanks! We appreciate your feedback 👍',
            type: 'success',
          });

          VueCookie.set(`faq-${this.question.id}-helpful`, true, {
            expires: 1,
          });
        } else {
          this.axios
            .post(formatUrl('/omnis/v3/contact/log-helpful/'), {
              question_id: this.question.id,
            })
            .then(({data}) => {
              this.loadingUnhelpful = false;
              this.$dialogs.showSnackBar(data);
              VueCookie.set(`faq-${this.question.id}-helpful`, true, {
                expires: 1,
              });
            })
            .catch(() => {
              this.loadingUnhelpful = false;
              this.$dialogs.showSnackBar({
                message: 'Oops! Something went wrong, please try again later',
                type: 'error',
              });
            });
        }
      } else {
        this.$dialogs.showSnackBar({
          message: 'You can only rate a question once.',
          type: 'error',
        });
        this.loadingUnhelpful = false;
      }
    },

    onNotArrived() {
      this.$emit('not-arrived');
    },
  },
};
</script>

<style lang="scss" scoped>
.helpful {
  font-weight: bold;
}

.button-tray {
  margin: 0 -0.25rem;
}

.button-tray-item {
  @media (max-width: 767px) {
    flex: 1;
  }
  margin: 0 0.25rem;
  width: 150px;
}
</style>

<style lang="scss">
.help-question-list {
  .question {
    .answer {
      p {
        margin-top: 1em;
        margin-bottom: 1em;
      }
    }
  }
}
</style>
